export default KeyboardIcon = ({ size, char, ...props }) ->
  <div
    style={{
      width: size,
      height: size
      borderRadius: size/12
      background: '#444'
      boxShadow: "rgb(100, 100, 100) 0px -0px 1px 1px, rgb(0, 0, 0) -2px 2px 0px, rgb(140,140,140) -2px 2px 3px"
      display: 'inline-block'
      props.style...
    }}
  >
    <span
      style={{
        color: 'white'
        fontSize: size * 0.35
        marginLeft: -2
        fontWeight: 300
        lineHeight: "#{size}px"
        display: 'block'
        textAlign: 'center'
      }}
    >
      { char }
    </span>
  </div>